moduleViewApp.controller('showSeriesCtrl', ['$scope', '$window', '$location', '$routeParams', 'myPartnersService', 'DebugHelper', 'SeriesResource', 'SetsResource', 'MySeriesResource', 'SiteNavigationService', 'moduleContextService', 'ModulePermissionsHelper', ($scope, $window, $location, $routeParams, myPartnersService, DebugHelper, SeriesResource, SetsResource, MySeriesResource, SiteNavigationService, moduleContextService, ModulePermissionsHelper) ->
  DebugHelper.register('showSeriesCtrl', $scope)

  bootstrapData = angular.element("#module--container").data()

  _.assignIn $scope,
    defaultGoalImage: bootstrapData.defaultGoalImage
    defaultUserImage: bootstrapData.defaultUserImage
    series: {}
    sets: []

    showMemoryBank: false
    itemsLoaded: false
    setsLoaded: false
    routes: Packs.iKnowRoutes
    creatorPath: ""
    SiteNavigationService: SiteNavigationService

    currentTab: $routeParams.tab || "memory_bank"
    drawMemoryBank: false

    defaultDescription: "js.module_view.show_series.default_description"

    canEditSeries: ->
      SiteNavigationService.isCreate() && ModulePermissionsHelper.canEditModuleInPartnerContext($scope.series)

    saveSeries: (params) ->
      SeriesResource.update { id: $routeParams.series_id }
      , params
      , (success) ->
        return

    tileOffset: ->
      paddingWidth = 40
      angular.element("#site-navigation").width() + paddingWidth || paddingWidth

    fetchSets: ->
      promise = SeriesResource.sets id: $routeParams.series_id, ->
        $scope.sets = promise.response
        for set in $scope.sets
          if SiteNavigationService.isCreate()
            set.modulePath = Packs.iKnowRoutes.v2_create_set_path(set.id)
          else
            set.modulePath = Packs.iKnowRoutes.v3_learn_set_path(set.id)
        $scope.setsLoaded = true

    fetchSeries: ->
      moduleContextService.fetchModule($routeParams.series_id, 'series').then (module) ->
        $scope.series = module
        SiteNavigationService.setContext($scope.series, 'series')
        if $routeParams.course_id
          SiteNavigationService.setCourseId($routeParams.course_id)
        $scope.canEdit = $scope.canEditSeries()
        SiteNavigationService.can_edit = $scope.canEdit
        if myPartnersService.showPartnerModuleDetails()
          $scope.ltiStudyPath = $window.location.protocol + "//" + $window.location.host + '/lti/study/series/' + $scope.series.id

        $scope.publicModulePath = $window.location.protocol + "//" + $window.location.host + Packs.iKnowRoutes.v3_learn_series_path($scope.series.id)

        $scope.$watch "series.image.id", (newVal, oldVal) ->
          if $scope.series.image && (newVal != oldVal)
            $scope.saveSeries { icon_image_id: $scope.series.image.id }
    
        $scope.$watch "series.privacy_type.id", (newVal, oldVal) ->
          if $scope.series.privacy_type && (newVal != oldVal)
            $scope.saveSeries { privacy_type_id: $scope.series.privacy_type.id }
    
        $scope.creatorPath = ""

      , (error) ->
        console.error error      
        
    removeSet: (set) ->
      if $window.confirm("Are you sure you want to remove this set from " + $scope.series.name + "?")
        $scope.dirty = true
        $scope.sets = _.without($scope.sets,set)
        MySeriesResource.removeSet
          id: $scope.series.id
          set_id: set.id
        , (success) ->
          $scope.dirty = false

    sortableOptions:
      cursor: "move"
      forcePlaceholderSize: true
      placeholder: "drag--placeholder"
      cancel: ".unsortable"
      update: (e, ui) ->
        $scope.$apply ->
          $scope.dirty = true
          SetsResource.insert_at { position: ui.item.sortable.dropindex + 1 }
          ,
            series_id: $routeParams.series_id
            set_id: ui.item.scope().set.id
          , (success) ->
            $scope.dirty = false

  $scope.$on "moduleDropDown:delete", (event, removedId, moduleType) ->
    $location.path Packs.iKnowRoutes.v2_sets_path()

  myPartnersService.initialize().then () ->
    $scope.fetchSeries()
    $scope.fetchSets()
  
  $scope.$on '$routeChangeSuccess', ($event, current, previous) ->
    $scope.currentTab = current.locals.$tab
])
